import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import AuditProposals from "@/components/audit/AuditProposals";
import { TableSkeleton } from "@/components/ui/Skeleton";
import { trpc } from "@/lib/trpc";
import { Route as OrgRoute } from "./$orgSlug";
import { useAuditAccountId } from "./$orgSlug.audit";

// The Proposals tab (spec: `/:org/audit/proposals`): the account's Proposals.
export const Route = createFileRoute("/_authenticated/$orgSlug/audit/proposals")({
  component: ProposalsTab,
});

function ProposalsTab() {
  const { orgSlug } = Route.useParams();
  const { currentOrg } = OrgRoute.useLoaderData();
  const accountId = useAuditAccountId();
  const { data: viewer } = useQuery(trpc.organization.viewer.queryOptions());
  // The runner settles rows between visits; keep the list fresh while open.
  const { data } = useQuery({
    ...trpc.audit.proposals.queryOptions({ orgSlug, accountId }),
    refetchInterval: 30_000,
  });
  const canApprove = currentOrg.role === "admin" || viewer?.isSuperAdmin === true;
  return data ? (
    <AuditProposals orgSlug={orgSlug} proposals={data.proposals} canApprove={canApprove} />
  ) : (
    <TableSkeleton label="Loading Proposals" rows={5} columns={1} />
  );
}
